define('boxes/email-verification-box',['jquery', 'boxes/box', 'boxes/helpers/email-verification-handlers', 'boxes/events/bonus-event', 'boxes/events/loginEvent', 'boxes/helpers/verification',
    'all/comeon', 'all/paymentServices-toggles', 'all/jquery/jquery.mustache'], function ($, box, emailVerificationHandlers, bonusEvent, loginEvent,
                                                                                          verification, comeon, paymentServicesToggles) {
    'use strict';

    function getWithdrawVerificationUrl() {

        return paymentServicesToggles.useNewPaymentFormDataService()
            ? '/PaymentFormDataService/getWithdrawVerification' : '/pp?flow=GetWithdrawVerification';
    }

    function getDepositVerificationUrlForQuery() {

        return paymentServicesToggles.useNewPaymentFormDataService()
            ? '/PaymentFormDataService/getDepositVerification' + '?' : '/pp?flow=GetDepositVerification' + '&';
    }

    function checkBonus(emailVerification) {
        if (emailVerification.model.type === 'deposit' && typeof(emailVerification.model.templateData.resourceUrl) !== 'undefined') {
            bonusEvent.changeBonusHandler(emailVerification.$controller, emailVerification.$box, {
                description: emailVerification.model.templateData.description,
                depositBonus: emailVerification.model.templateData.depositBonus
            });
            if (emailVerification.model.isShopBonus) {
                var $selectedBonusButtons = emailVerification.$box.find('.selected-bonus span.s12-change').parent();
                $selectedBonusButtons.off('click').on('.click', function () {
                    $('#sliding-content-wrapper').find('.close').click();
                });
            }
        }
    }

    function setupWithdrawVerificationEventHandlers(emailVerification) {
        $.get(getWithdrawVerificationUrl(), function (verificationData) {
            emailVerification.model.templateData = {};
            $.extend(emailVerification.model.templateData, {
                email: verificationData.email,
                bonusNotApplicable: emailVerification.model.type !== 'deposit',
                emailChangeNotApplicable: emailVerification.model.type === 'forgottenPassword'
            });
            emailVerification.model.shouldVerify = verificationData.verifyEmail;
            emailVerification.model.initPromise.resolve();
        });
    }

    function setupForgottenPasswordVerificationEventHandlers(emailVerification) {
		emailVerification.$controller.on(loginEvent.SKIP_EMAIL_VERIFICATION, function (event, email) {
			event.preventDefault();
			emailVerification.model.initPromise.resolve();
			emailVerification.model.shouldVerify = false;
		});

        emailVerification.$controller.on(loginEvent.VERIFY_EMAIL, function (event, email) {
            event.preventDefault();
            emailVerification.model.templateData = {};
            $.extend(emailVerification.model.templateData, {
                email: email,
                bonusNotApplicable: true,
                emailChangeNotApplicable: true
            });
            emailVerification.model.shouldVerify = true;
            emailVerificationHandlers.setDoneCallback(function (data) {
                // A new init promise is created in beforeRender, it has to be resolved as well...
                emailVerification.model.initPromise.resolve();
                // Pass emailVerification box next time
                emailVerification.model.shouldVerify = false;

                // Go back to forgottenPasswordBox
                var slidedPromise = emailVerification.$controller.previousBox();
                comeon.promise.when(slidedPromise)
                    .done(function () {
                        emailVerification.$controller.trigger(
                            loginEvent.EMAIL_IS_VERIFIED,
                            {
                                PARAM_USER_NAME: data.PARAM_USER_NAME,
                                PARAM_EMAIL: data.PARAM_EMAIL
                            });
                    });

            });
            emailVerification.model.initPromise.resolve();
        });
    }

    function setupDepositVerificationEventHandlers(emailVerification) {
        emailVerification.$controller.on(bonusEvent.BONUS_CHANGED, function (event, bonusData) {
            var parameterData = { isBonusSelected: true };
            if (bonusData.isFree === true) {
                $.extend(parameterData, { isBonusFree: true });
            } else {
				$.extend(parameterData, { isBonusFree: false });
			}

            emailVerification.model.isShopBonus = bonusData.isShop;

            $.get(getDepositVerificationUrlForQuery() + $.param(parameterData), function (verificationData) {
                emailVerification.model.templateData = {};
                $.extend(emailVerification.model.templateData, {
                    email: verificationData.email,
                    bonusNotApplicable: emailVerification.model.type !== 'deposit',
                    emailChangeNotApplicable: emailVerification.model.type === 'forgottenPassword',
                    skipButton: (typeof(verificationData.isBlacklisted) === 'undefined')
                }, bonusData);
                emailVerification.model.shouldVerify = verificationData.verifyEmail;
                emailVerification.model.initPromise.resolve();
            });
        });
        emailVerification.$controller.on(bonusEvent.NO_SELECTED_BONUS, function () {
            emailVerification.model.isShopBonus = false;
            $.get(getDepositVerificationUrlForQuery() + 'isBonusSelected=false', function (verificationData) {
                emailVerification.model.templateData = {};
                $.extend(emailVerification.model.templateData, {
                    email: verificationData.email,
                    bonusNotApplicable: emailVerification.model.type !== 'deposit',
                    emailChangeNotApplicable: emailVerification.model.type === 'forgottenPassword',
                    skipButton: (typeof(verificationData.isBlacklisted) === 'undefined')
                });
                emailVerification.model.shouldVerify = verificationData.verifyEmail;
                emailVerification.model.initPromise.resolve();
            });
        });

        emailVerification.$controller.on(bonusEvent.RESET_VERIFICATION, function () {
            if (emailVerification.model.type === 'deposit') {
                emailVerification.model.initPromise = comeon.promise.create();
            }
        });

    }

    var view = {
            render: function (emailVerification) {
                var mustacheTemplateId = 'verification-email-template';
                $.Mustache.addFromDom(mustacheTemplateId);
                emailVerification.$box.mustache(mustacheTemplateId, emailVerification.model.templateData, {
                    method: 'html'
                });
            }
        },
        model = {
            templateData: {},
            shouldVerify: undefined,
            isShopBonus: false,
            initPromise: undefined,
            buttonHandlers: {
                updateHandler: emailVerificationHandlers.updateEmail,
                resendHandler: emailVerificationHandlers.resendEmail,
                verifyHandler: emailVerificationHandlers.verifyEmail
            },
            init: function (emailVerification) {
                emailVerification.model.initPromise = comeon.promise.create();
                if (emailVerification.model.type === 'deposit') {
                    setupDepositVerificationEventHandlers(emailVerification);
                }
                if (emailVerification.model.type === 'forgottenPassword') {
                    setupForgottenPasswordVerificationEventHandlers(emailVerification);
                }

            },
            beforeRender: function (emailVerification) {
                if (emailVerification.model.type === 'withdraw') {
                    setupWithdrawVerificationEventHandlers(emailVerification);
                }
                var shouldVerifyPromise = comeon.promise.create();
                comeon.promise.when([emailVerification.model.initPromise])
                    .done(function () {
                        if (emailVerification.model.shouldVerify) {
                            shouldVerifyPromise.resolve();
                        } else {
                            shouldVerifyPromise.reject();
                        }
                    }).always(function () {
                    emailVerification.model.initPromise = comeon.promise.create();
                });
                return [shouldVerifyPromise.promise()];
            },
            afterRender: function (emailVerification) {
                emailVerificationHandlers.resendEmail(emailVerification.$box, true);
                verification.setupVerificationButtons(emailVerification.$box, emailVerification.$controller, emailVerification.model.buttonHandlers);
				if(emailVerification.model.templateData.fromCarousel) {
					if(!emailVerification.model.templateData.verifyMobile) {
						//if we dont need mobile verification, return to carousel
						emailVerificationHandlers.setDoneCallback(function (data, $box, $controller) {
							$controller.boxes[$controller.currentBoxIndex-1].model.chosenBonusId = emailVerification.model.templateData.id;
							$controller.currentBoxIndex -= 2;
							$controller.nextBox();
						});
					}
				}
                checkBonus(emailVerification);


            }
        };

    return {
        create: function ($box, $controller, type) {
            var emailVerificationModelWithType = $.extend({}, model, {type: type});
            return box.create($box, $controller, view, emailVerificationModelWithType);
        }
    };
});

